<template>
  <div class="ac-content-wrapper">
    <div class="header" style="font-weight: 500;">
      Name App
    </div>
    <div class="sub-header">
      Custom naming is currently only available for Android devices.
    </div>
    <div class="ac-text-input-container">
      <SACInput
        field="appName"
        :value="appName"
        :max="20"
        :change="onChange"
        placeholder="Insert text"
      />
      <div class="ac-text-counter">
        {{ appName.length }}/20 characters
      </div>
    </div>
  </div>
</template>

<script>
import SACInput from '@shared/components/sac/SACInput.vue';

export default {
  name: 'AppName',
  components: {
    SACInput,
  },
  props: {
    appName: String,
    onChange: Function,
  },
};
</script>
